import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '../icons/CheckIcon';
import PlusIcon from '../icons/PlusIcon';
import SuccessCard from '../SuccessCard/SuccessCard';
import ErrorCard from '../ErrorCard/ErrorCard';
import { CircleSpinner } from 'react-spinners-kit';
import Box from '../Box/Box';
import InputPill from '../Common/InputPill/InputPill';

const VoucherRedemption = ({ onApplyVoucher, onRemoveVoucher, status, errorCode }) => {
  const { t } = useTranslation();
  const [voucherCode, setVoucherCode] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenBox = () => {
    setIsOpen(!isOpen);
  };

  const handleValidateVoucher = async () => {
    if (status === 'VALIDATING' || voucherCode.length === 0 || voucherCode === null) return;

    onApplyVoucher(voucherCode);
  };

  const handleRemoveVoucher = async () => {
    setVoucherCode('');
    onRemoveVoucher();
  };

  return (
    <>
      <div
        className='section-title d-flex align-items-center'
        onClick={handleOpenBox}
        style={{ gap: '5px', cursor: 'pointer' }}
      >
        {t('voucherDiscount')} <PlusIcon size={16} color='var(--color-primary)' />
      </div>
      <div className={['box-wrapper', isOpen ? 'show' : ''].join(' ')}>
        <Box>
          <div className='text-secondary font-tiny fw-400 mb-3'>
            {t('voucherDiscountDescription')}
          </div>
          {status !== 'VALID_COUPON' && (
            <div className='d-flex' style={{ gap: '10px' }}>
              <InputPill
                name={'voucherCode'}
                type={'text'}
                value={voucherCode}
                placeholder={t('discountCoupon')}
                onChange={(e) => setVoucherCode(e.target.value)}
                autoComplete='off'
              />

              <button
                className='btn btn-primary btn-pill btn-small position-relative'
                onClick={handleValidateVoucher}
              >
                <span
                  style={{
                    visibility: status === 'VALIDATING' ? 'visible' : 'hidden',
                    display: 'inline-block',
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    transform: 'translate(-50%, -50%)',
                  }}
                >
                  <CircleSpinner size={20} color='#fff' />
                </span>
                <span style={{ visibility: status !== 'VALIDATING' ? 'visible' : 'hidden' }}>
                  {t('apply')}
                </span>
              </button>
            </div>
          )}

          {status === 'VALID_COUPON' && (
            <div className='position-relative'>
              <SuccessCard
                title={voucherCode}
                description={
                  <>
                    <CheckIcon size='16px' color='#2BD14C' /> {t('discountAdded')}
                  </>
                }
              />
              <div
                className='text-secondary font-tiny fw-400 mt-2 text-center'
                onClick={handleRemoveVoucher}
              >
                {t('delete')}
              </div>
            </div>
          )}

          {errorCode && (
            <div className='mt-2'>
              <ErrorCard
                title={t('promotionError.' + errorCode)}
                description={t('checkTryAgain')}
              />
            </div>
          )}
        </Box>
      </div>
    </>
  );
};

export default VoucherRedemption;
